import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import Dashboard from '../components/Dashboard';
import dashboardsConfig from '../config/dashboards.json';

const BIDashboard = () => {
  const { dashboardId } = useParams();
  
  const dashboard = dashboardsConfig.dashboards.find(
    (item) => item.id === dashboardId
  );

  if (!dashboard) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>未找到对应的仪表板</h2>
        <p>请检查链接是否正确</p>
      </div>
    );
  }

  return (
    <div style={{ height: '100vh', overflow: 'hidden' }}>
      <Header title={dashboard.title} showBackButton={true} />
      <Dashboard url={dashboard.url} title={dashboard.title} />
    </div>
  );
};

export default BIDashboard; 
